import { ChangeDetectionStrategy, EventEmitter } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-add-cronjob-rule-modal',
    templateUrl: './add-cronjob-rule-modal.component.html',
    styleUrls: ['./add-cronjob-rule-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AddCronjobRuleModalComponent implements OnInit {
    addRuleFormGroup: UntypedFormGroup;
    @Output() closeEvent = new EventEmitter<number>();

    constructor(private fb: UntypedFormBuilder, public activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        this.addRuleFormGroup = this.fb.group({
            daysBefore: [0, [Validators.max(31), Validators.required, Validators.min(0)]],
        });
    }

    submit() {
        this.closeEvent.emit(this.addRuleFormGroup.get('daysBefore').value);
        this.activeModal.close();
    }
}
